module.exports = __webpack_public_path__ + "img/56.2ba075f1.svg";